import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import uuid from 'react-uuid';
import { SIZES } from '../../sizes';

export const Breadcrumbs = ({ isMenuToggled }) => {
    const location = useLocation();
    const [breadcrumbs, setBreadcrumbs] = useState([]);

    const ok = true;//!SIZES.isMobileDevice() //|| !isMenuToggled;

    /*const prefixList = ["text", "frequency", "color", "multi"];*/

    const formatName = (name) => {
        /*  const match = prefixList.find(item => name.includes(item));*/
        if (name === '') return "Home";

        if (name.includes("-")) {
            //let secondWord = name.slice(match.length);
            //secondWord = secondWord.charAt(0).toUpperCase() + secondWord.slice(1);
            //name = name.slice(0, match.length) + ' ' + secondWord;
            const resultArray = name.split("-").map(item => item.charAt(0).toUpperCase() + item.slice(1));

            return resultArray.join(" ");
        }


        return name.charAt(0).toUpperCase();
    }

    const generateBreadcrumbs = (path, currentBreadcrumb) => {

        let pathParts = path == '/' ? [''] : path.split('/');

        const breadcrumbItems = pathParts.map((part, index) => {

            const url = pathParts.slice(0, index + 1).join('/');
            const name = formatName(part);

            return (
                <React.Fragment key={uuid()}>
                    {name != 'Home' &&
                        <FontAwesomeIcon icon="fa fa-chevron-right" className="breadcrumbs__arrow" size="xs" />
                    }

                    {index < pathParts.length - 1 ? (<NavLink to={url} className="breadcrumbs__item">
                        {name}
                    </NavLink>) :
                        (<span className="breadcrumbs__item breadcrumbs__item--last">{name}</span>)}
                </React.Fragment>
            );
        });
        return [...currentBreadcrumb, ...breadcrumbItems];
    };

    // Generate breadcrumbs on route change
    useEffect(() => {
        setBreadcrumbs(generateBreadcrumbs(location.pathname, []));
    }, [location]);

    return ok ?
        <div className="breadcrumbs">
            <div className="breadcrumbs__inner d-flex justify-center-center align-items-center gap-1 gap-md-3">
                {breadcrumbs}
            </div>
        </div>
        : <></>;
};

/*export default Breadcrumbs;*/
